import * as utility from 'stdjs/utility';


export function showDeletedMessage( message, sticky ){
    return showSingleMessage( 'deleted', message, sticky );
}

export function showErrorMessage(message, sticky){
    return showSingleMessage('error', message, sticky);
}

export function showWarningMessage(message, sticky){
    return showSingleMessage('warning', message, sticky);
}

export function showInfoMessage(message, sticky){
    return showSingleMessage('info', message, sticky);
}

export function showSuccessMessage( message, sticky ){
    return showSingleMessage( 'success', message, sticky );
}

export function showMessage( message, sticky ){
    return showInfoMessage( message, sticky );
}

const toastHeaders = {
    'error': 'Error',
    'warning': 'Warning',
    'info': 'Info',
    'success': 'Success',
    'deleted': 'Deleted'
}

export function showSingleMessage(type, message, sticky){
    if (typeof sticky === "undefined" || sticky === null){
        sticky = false;
    }
    
    var duration = sticky ? '-1' : ( type === 'error' ? '10000' : '5000' );
    
    var $icon = $( '#toast-template-icon-' + type ).clone();
    $icon.removeAttr( "id" );
    
    var $toast = $( '#toast-template' ).clone();
    $toast.removeAttr( 'id' );
    $toast.removeClass( 'toast-template' );
    $toast.addClass( 'toast' );
    $toast.attr( 'data-category', type );
    $toast.attr( 'data-duration', duration );
    
    $toast.find( '#toast-template-icon' ).replaceWith( $icon );
    $toast.find( '#toast-template-header' ).removeAttr( 'id' ).text( toastHeaders[ type ] ?? 'Info' );
    $toast.find( '#toast-template-message' ).removeAttr( 'id' ).html( message );
    
    $( '#toaster' ).append( $toast );
}

// TODO UI sort these.
/*
export function displayMessages(errorMessages, warningMessages, infoMessages) {

    if (typeof errorMessages !== "undefined" && errorMessages.length > 0) {

        for (var i = 0; i < errorMessages.length; i++) {
            $.jGrowl(errorMessages[i], {header: Translator.tr("Error"), sticky: true, theme: "jError"});
        }

    }

    if (typeof warningMessages !== "undefined" && warningMessages.length > 0) {

        for (var i = 0; i < warningMessages.length; i++) {
            $.jGrowl(warningMessages[i], {header: Translator.tr("Warning"), sticky: false, theme: "jWarn"});
        }

    }

    if (typeof infoMessages !== "undefined" && infoMessages.length > 0) {
        
        for (var i = 0; i < infoMessages.length; i++) {
            $.jGrowl(infoMessages[i], {header: Translator.tr("Information"), sticky: false, theme: "jInfo"});
        }

    }
    
}

export function destroyMessages() {
    $("div.jGrowl-notification").trigger('jGrowl.close');    
}
*/
